import { useState } from 'react';
import { readSpreadsheetFile } from '../utils/spreadsheet';

const useReadSpreadsheetFile = () => {
    const [workbook, setWorkbook] = useState();
    // const resetWorkbook = () => setWorkbook(undefined);

    const onFileUpload = (file) => {
        if (file) {
            readSpreadsheetFile(file)
                .then((value) => {
                    setWorkbook(value);
                })
                .catch((err) => console.error(err));
        }
    };
    // return [workbook, resetWorkbook, onFileUpload];
    return [workbook, onFileUpload];
};

export default useReadSpreadsheetFile;
